// Shows a server-rendered region only between data-start and data-end (Unix seconds, 0 = no limit).
// The server already renders the right state; this keeps cached pages on schedule and flips the
// region at the exact moment while the page stays open.
const MAX_DELAY = 2147483647;

class SSchedule extends HTMLElement {
  #timer = 0;

  connectedCallback() {
    this.start = Number(this.dataset.start || 0) * 1000;
    this.end = Number(this.dataset.end || 0) * 1000;
    this.#update();
  }

  disconnectedCallback() {
    window.clearTimeout(this.#timer);
  }

  #update() {
    window.clearTimeout(this.#timer);
    const now = Date.now();
    const started = !this.start || now >= this.start;
    const ended = this.end > 0 && now >= this.end;
    this.hidden = !started || ended;
    const next = !started ? this.start : (!ended && this.end ? this.end : 0);
    if (next) {
      this.#timer = window.setTimeout(() => this.#update(), Math.min(next - now + 50, MAX_DELAY));
    }
  }
}

if (!customElements.get('s-schedule')) {
  customElements.define('s-schedule', SSchedule);
}
